import { render, staticRenderFns } from "./bankCardPay.vue?vue&type=template&id=af4013d2&scoped=true&"
import script from "./bankCardPay.vue?vue&type=script&lang=js&"
export * from "./bankCardPay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af4013d2",
  null
  
)

export default component.exports